import AlertModel from '@/common/models/alerts/alert-model';

export default [
    /**
     * The profile timezone alert
     * https://jira.ilabsinc.com/browse/GWY-10284
     * https://github.com/Rebilly/frontend-recomm/pull/1546
     *
     * When the profile timezone !== real local browser timezone
     * we should notify the user about this
     */
    new AlertModel({
        title: 'Time zone warning',
        message: `Your profile time zone does not match the detected browser time zone. \r\nSee details on the profile page.`,
        type: AlertModel.Types.link,
        params: {to: {name: 'profile'}},
        condition: ({$store}) => {
            const {browserTimezone} = $store.state.app;
            const hasProfileTimezoneDiff = $store.getters['app/hasProfileTimezoneDiff'];
            const {mutedTimezoneNameDiff} = $store.getters['user/uiPreferences'].notifications;

            return hasProfileTimezoneDiff && mutedTimezoneNameDiff !== browserTimezone;
        },
    }),
];
